import * as Accordion from "@radix-ui/react-accordion";
import { clsx } from "clsx";
import classes from "./Accordion.module.scss";
import type {
  AccordionGroupProps,
  AccordionItemProps,
  AccordionTriggerProps,
  AccordionContentProps,
} from "./AccordionProps";

export function AccordionGroup(props: AccordionGroupProps) {
  const { className, children, onChange, value, disabled, ref } = props;

  return (
    <Accordion.Root
      ref={ref}
      className={clsx(classes.group, className)}
      type="single"
      value={value ?? ""}
      onValueChange={onChange}
      disabled={disabled}
    >
      {children}
    </Accordion.Root>
  );
}

export function AccordionItem(props: AccordionItemProps) {
  const { className, value, children, ref } = props;

  return (
    <Accordion.Item
      ref={ref}
      className={clsx(classes.item, className)}
      value={value}
    >
      {children}
    </Accordion.Item>
  );
}

export function AccordionTrigger(props: AccordionTriggerProps) {
  const { children, className, adornmentText = "Edit" } = props;

  return (
    <Accordion.Header className={classes.header} tabIndex={-1}>
      <Accordion.Trigger className={clsx(classes.trigger, className)}>
        <span className={classes.title}>{children}</span>
        <span className={classes.editButton}>{adornmentText}</span>
      </Accordion.Trigger>
    </Accordion.Header>
  );
}

// The open item's trigger is `aria-disabled` (a single accordion cannot close
// it), so a screen reader would call it unavailable. The heading names the
// open item without that.
export function openItemHeading(group: HTMLElement | null) {
  return group?.querySelector<HTMLElement>(
    `.${classes.header}[data-state="open"]`,
  );
}

export function AccordionContent(props: AccordionContentProps) {
  const { children, className } = props;

  return (
    <Accordion.Content forceMount className={clsx(classes.content, className)}>
      <div className={classes.inner}>{children}</div>
    </Accordion.Content>
  );
}
